import { useAuthStore } from "@persisted-state/auth/auth.store";
import { checkPermission } from "@utils/user-permissions";

export type BayHireEntryState = "allowed" | "denied" | "unavailable";

export interface UseBayHireEntryStateResult {
  entryState: BayHireEntryState;
  companyId: string;
  isOperationsUser: boolean;
}

export const useBayHireEntryState = (): UseBayHireEntryStateResult => {
  const user = useAuthStore((state) => state.user);
  const userActionPermissions = useAuthStore((state) => state.userActionPermissions) ?? [];
  const isOperationsUser = useAuthStore((state) => state.isOperationsUser) ?? false;

  const canRequestBayHire = checkPermission(userActionPermissions, "canRequestBayHire");
  const companyId = typeof user?.companyId === "string" ? user.companyId.trim() : "";
  const hasCompanyContext = companyId.length > 0;

  let entryState: BayHireEntryState;
  if (!canRequestBayHire) {
    entryState = "denied";
  } else if (!hasCompanyContext) {
    entryState = "unavailable";
  } else {
    entryState = "allowed";
  }

  return { entryState, companyId, isOperationsUser };
};
